import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "~/utils/trpc.client";
import { TeammatesCard } from "~/app/(new)/[teamId]/admin/TeammatesCard";
import { TeamInviteLinkCard } from "~/app/(new)/[teamId]/admin/TeamInviteLinkCard";
import { TeamInfoCard } from "~/app/(new)/[teamId]/admin/TeamInfoCard";
import { TeamFeatureFlagsCard } from "~/app/(new)/[teamId]/admin/TeamFeatureFlagsCard";
import { BASE_URL } from "~/utils/baseUrl";

/** Team admin (was (new)/[teamId]/admin/page.tsx). */
export const Route = createFileRoute("/_authed/$teamId/admin")({
  component: TeamAdminPage,
});

function TeamAdminPage() {
  const { teamId } = Route.useParams();

  const teamQuery = trpc.team.getTeamById.useQuery({ id: teamId });
  const teammatesQuery = trpc.team.getTeammatesByTeamId.useQuery({ id: teamId });

  if (teamQuery.isLoading || teammatesQuery.isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  if (!teamQuery.data || !teammatesQuery.data) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="text-error">Team not found</div>
      </div>
    );
  }

  const team = teamQuery.data;
  const teammates = teammatesQuery.data;

  return (
    <div className="flex flex-col gap-4 mx-auto max-w-3xl mt-6 px-4 w-full">
      <TeamInfoCard team={team} />
      <TeammatesCard teammates={teammates} />
      <TeamInviteLinkCard team={team} baseUrl={BASE_URL} />
      <TeamFeatureFlagsCard team={team} />
    </div>
  );
}
